import Container from "@/components/atoms/Container";
import PageHeader from "@/components/molecules/PageHeader";
import AutoInvoiceForm, {
  AutoInvoiceProps,
  useAutoInvoiceForm,
} from "@/components/organisms/AutoInvoice/Form";
import CreditNoteForm, {
  CreditNoteFormProps,
  useCreditNoteForm,
} from "@/components/organisms/AutoInvoice/CreditNoteForm";
import ManualCreditNoteForm, {
  ManualCreditNoteFormProps,
  useManualCreditNoteForm,
} from "@/components/organisms/AutoInvoice/ManualCreditNoteForm";
import ProformaForm, {
  ProformaProps,
  useProformaForm,
} from "@/components/organisms/AutoInvoice/ProformaForm";
import ManualInvoiceForm, {
  ManualInvoiceProps,
  useManualInvoiceForm,
} from "@/components/organisms/AutoInvoice/ManualInvoiceForm";
import useMessageProps from "@/hooks/useMessageProps";
import AutoInvoice from "@/types/AutoInvoice";
import { router } from "@inertiajs/react";
import { useState } from "react";

type Props = (AutoInvoiceProps | CreditNoteFormProps | ProformaProps | ManualInvoiceProps | ManualCreditNoteFormProps) & {
  autoInvoice: AutoInvoice;
  redirect_props: any;
};

const NewAutoInvoice = ({ autoInvoice, redirect_props, ...rest }: Props) => {
  const form = rest.invoice_type === 'MANUAL CREDIT NOTE' 
    ? useManualCreditNoteForm(autoInvoice)
    :  rest.invoice_type === 'CREDIT NOTE' 
    ? useCreditNoteForm(autoInvoice) 
    : rest.invoice_type === 'PROFORMA INVOICE' 
    ? useProformaForm(autoInvoice)
    : rest.invoice_type === 'MANUAL INVOICE'
    ? useManualInvoiceForm(autoInvoice) 
    : useAutoInvoiceForm(autoInvoice);
  const [loading, setLoading] = useState(false);

  useMessageProps({ redirect_props });

  const onSubmit = (data: any) => {
    router.post(`/auto_invoices`, data, {
      onStart: () => setLoading(true),
      onFinish: () => setLoading(false),
    });
  };

  return (
    <Container>
      <PageHeader title={`New ${rest.invoice_type}`} />

      {rest.invoice_type === "MANUAL CREDIT NOTE" ? (
        <ManualCreditNoteForm
         form={form}
         edit={true}
         autoInvoice={autoInvoice}
         onSubmit={onSubmit}
         data={rest}
         loading={loading}
         mode="create"
         errors={redirect_props?.errors}
       />
      ) : rest.invoice_type === "CREDIT NOTE" ? (
        <CreditNoteForm
          form={form}
          edit={true}
          autoInvoice={autoInvoice}
          onSubmit={onSubmit}
          data={rest}
          loading={loading}
          mode="create"
          errors={redirect_props?.errors}
        />
      ) : rest.invoice_type === "PROFORMA INVOICE" ? (
        <ProformaForm
          form={form}
          edit={true}
          autoInvoice={autoInvoice}
          onSubmit={onSubmit}
          data={rest}
          loading={loading}
          mode="create"
          errors={redirect_props?.errors}
        />
      ) : rest.invoice_type === "MANUAL INVOICE" ? (
        <ManualInvoiceForm
          form={form}
          edit={true}
          autoInvoice={autoInvoice}
          onSubmit={onSubmit}
          data={rest}
          loading={loading}
          mode="create"
          errors={redirect_props?.errors}
        />
      ) : (
        <AutoInvoiceForm
          form={form}
          edit={true}
          autoInvoice={autoInvoice}
          onSubmit={onSubmit}
          data={rest}
          loading={loading}
          mode="create"
          errors={redirect_props?.errors}
        />
      )}

    </Container>
  );
};

export default NewAutoInvoice;
